module.exports = __webpack_public_path__ + "static/media/snacks.c3d22c26.svg";